exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.popover-item {\n    text-decoration: none;\n    height: 26px;\n    width: 26px;\n    border: 1px #c4c9cd solid;\n    border-radius: 50%;\n    padding-left: 2px;\n    padding-bottom: 3px;\n    display: inline-flex;\n    margin-left: 3px;\n}\n.popover-item:hover {\n    text-decoration: none;\n}\n.popover-item span {\n    padding-left: 6px;\n    padding-right: 8px;\n    color: #c4c9cd;\n    text-align: center;\n    line-height: 2.8rem;\n    font-size: 1.6rem;\n    font-weight: 300;\n}\n.popover {\n    max-width: 600px;\n    padding:10px;\n}\n", ""]);

// exports
